import Crud from '../views/Tipo_Profissional/Crud'
import Entity from '../views/Tipo_Profissional/Add'

let routes = {
    path: '/tipo_profissionais',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_profissionais/add',
            name: 'NewTipoProfissional',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Tipo Profissional',
                breadcrumb: [
                    {
                        text: 'Tipos de Profissional',
                        to: '/tipo_profissionais',
                        active: false,
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_profissionais/edit/:id?',
            name: 'EditTipoProfissional',
            component: Entity,
            meta: {
                pageTitle: 'Editar Tipo Profissional',
                breadcrumb: [
                    {
                        text: 'Tipos de Profissional',
                        to: '/tipo_profissionais',
                        active: false,
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_profissionais',
            name: 'list-tipo_profissionais',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Profissional',
                breadcrumb: [
                    {
                        text: 'Tipos de Profissional',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
